export var CREHANA_BRANDING = {
  paletteColors: {
    v1: {
      darkest: '#140058',
      dark: '#4B22F4',
      base: '#6556FF',
      light: '#A69EFE',
      lightest: '#E9E7FF'
    }
  },
  imageLogo: {
    id: 'https://crehana-vercel-images-prd.imgix.net/public/hris-white-label/09f1bc37-394b-4f9a-a10e-ddef0ead1ed3-logo-crehana.png',
    absoluteUrl: 'https://crehana-vercel-images-prd.imgix.net/public/hris-white-label/09f1bc37-394b-4f9a-a10e-ddef0ead1ed3-logo-crehana.png'
  },
  imageIsotype: {
    id: 'https://crehana-vercel-images-prd.imgix.net/public/hris-white-label/b190cb27-ca59-4875-bc1e-5728582907be-iso-crehana-bg-(1).png',
    absoluteUrl: 'https://crehana-vercel-images-prd.imgix.net/public/hris-white-label/b190cb27-ca59-4875-bc1e-5728582907be-iso-crehana-bg-(1).png'
  },
  imageFavicon: {
    id: 'https://crehana-vercel-images-prd.imgix.net/public/white-label-hris/07f3be0d-619d-4fbf-aacd-d5ef378e17c8-favicon-crehana.png',
    absoluteUrl: 'https://crehana-vercel-images-prd.imgix.net/public/white-label-hris/07f3be0d-619d-4fbf-aacd-d5ef378e17c8-favicon-crehana.png'
  },
  imagePageLoginHero: {
    id: 'https://crehana-vercel-images-prd.imgix.net/public/hris-white-label/6c9c1752-c40e-412e-880d-09b1817474f5-imagen_bienvenida-(2).png?auto=format',
    absoluteUrl: 'https://crehana-vercel-images-prd.imgix.net/public/hris-white-label/6c9c1752-c40e-412e-880d-09b1817474f5-imagen_bienvenida-(2).png?auto=format'
  }
};